import {
  fetchUserAttributes,
  getCurrentUser,
  signInWithRedirect,
  signOut,
} from 'aws-amplify/auth';

const RETURN_TO_KEY = 'loop-dashboard:return-to';
const SELECT_ACCOUNT_ON_NEXT_LOGIN_KEY = 'loop-dashboard:select-account-on-next-login';

export async function login(returnTo = '/'): Promise<void> {
  sessionStorage.setItem(RETURN_TO_KEY, safeReturnTo(returnTo));
  const selectAccount = sessionStorage.getItem(SELECT_ACCOUNT_ON_NEXT_LOGIN_KEY) === 'true';
  sessionStorage.removeItem(SELECT_ACCOUNT_ON_NEXT_LOGIN_KEY);

  if (selectAccount) {
    await signInWithRedirect({ options: { prompt: 'SELECT_ACCOUNT' } });
    return;
  }

  await signInWithRedirect();
}

export async function logout({ selectAccountOnNextLogin = false } = {}): Promise<void> {
  if (selectAccountOnNextLogin) {
    sessionStorage.setItem(SELECT_ACCOUNT_ON_NEXT_LOGIN_KEY, 'true');
  } else {
    sessionStorage.removeItem(SELECT_ACCOUNT_ON_NEXT_LOGIN_KEY);
  }
  await signOut();
}

export async function isAuthenticated(): Promise<boolean> {
  try {
    await getCurrentUser();
    return true;
  } catch {
    return false;
  }
}

export async function getUserEmail(): Promise<string> {
  try {
    const attributes = await fetchUserAttributes();
    if (attributes.email) return attributes.email;

    const user = await getCurrentUser();
    return user.signInDetails?.loginId ?? user.username;
  } catch {
    return '';
  }
}

export function consumeReturnTo(): string {
  const returnTo = safeReturnTo(sessionStorage.getItem(RETURN_TO_KEY) ?? '/');
  sessionStorage.removeItem(RETURN_TO_KEY);
  return returnTo;
}

const safeReturnTo = (value: string): string => {
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/auth/callback')) {
    return '/';
  }
  return value;
};
